/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_LabelInputs */

const en_why_listening_zotero_label = /** @type {(inputs: Why_Listening_Zotero_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero import`)
};

const es_why_listening_zotero_label = /** @type {(inputs: Why_Listening_Zotero_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación desde Zotero`)
};

/**
* | output |
* | --- |
* | "Zotero import" |
*
* @param {Why_Listening_Zotero_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_label = /** @type {((inputs?: Why_Listening_Zotero_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_label(inputs)
	return en_why_listening_zotero_label(inputs)
});